import { useState, useEffect } from 'react';

/**
 * Custom hook to manage string component logic
 * Shared between StringsComponent (desktop) and StringComponentMobile
 */
export const useStringLogic = (data, onQtyChange) => {
  const [strings, setStrings] = useState([]);

  useEffect(() => {
    if (data !== undefined) {
      // Filter strings data (type === 2)
      const stringsFiltered = data.filter((item) => item.type === 2);
      setStrings(stringsFiltered);
    }
  }, [data]);

  const handleQtyChange = (value, id, name, bandType, memberData) => {
    // Ensure value is within min/max bounds
    const newValue = Math.max(
      memberData?.min || 0,
      Math.min(memberData?.max || 10, value)
    );
    // Call onQtyChange with correct parameter order for BandConfiguration
    // onQtyChange expects: (qty, positionId, "strings", type)
    onQtyChange && onQtyChange(newValue, id, name, bandType);
  };

  const calculateTotalPrice = (stringItems = strings) => {
    return stringItems.reduce((sum, member) => {
      return sum + (member.rate || 0) * (member.default || 0);
    }, 0);
  };

  const processStringMembers = (rawData = data) => {
    const filteredData = rawData?.filter((item) => item.type === 2) || [];
    return filteredData.map(member => ({
      ...member,
      // Ensure we have default values if not provided
      name: member.name || '',
      rate: member.rate || 0,
      default: member.default || 0,
      min: member.min || 0,
      max: member.max || 10,
      isRequired: member.isRequired || false,
      isIncluded: member.isIncluded || false,
    }));
  };

  return {
    strings,
    handleQtyChange,
    calculateTotalPrice,
    processStringMembers,
  };
};